import { graphql } from 'relay-runtime';

export const UNIFIED_CONSENT_QUERY = graphql`
  query UnifiedConsentQuery($aaid: String!) {
    unified {
      consent {
        getConsent(value: $aaid) {
          ... on UnifiedConsentStatus {
            id
            consentObj {
              consentKey
              consentStatus
              consenthubStatus
              uppConsentStatus
            }
            updatedAt
            value
          }
          ... on UnifiedQueryError {
            code
            identifier
          }
        }
      }
    }
  }
`;
